import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/smp')({
	beforeLoad: ({ context: { isInternalAdmin } }) => {
		if (!isInternalAdmin) {
			throw redirect({ to: '/' })
		}
	},
})
